module.exports = __webpack_public_path__ + "img/oki.3a5984a4.png";